import { createContext, useContext, useReducer } from "react";
import { HomeIcon } from "@heroicons/react/24/outline";

export const ChatContext = createContext();

export const ChatContextProvider = ({ children }) => {
 
  const INITIAL_STATE = {
    channelId: "null",
    customer: "Customer",
    accountNo: 0,
    user: {},
    accountData: {
      "account": {},
      "balance":0,
      "balance_data":{},
      "comments": [],
      "connection_status": 0,
      "location": [],
      "transactions": []
  },
    isAccountDataLoading: false, // Initialize isAccountDataLoading
    _accountDataVersion: 0, // Debugging counter
    categoryId: 1,
    activeChats: [],
    lastMessages: [],
    currentChat: {"channel_id": 0},
    navigation: [{ name: "Home", action: "SHOW_ADDRESS", icon: HomeIcon }],
    tab: "Home"
  };

 const chatReducer = (state, action) => { 
  switch (action.type) {
    case "CHANGE_CHAT":
      return { 
        ...state,
        channelId:  action.payload
      }; 
    case "SET_CATEGORY":
      return { 
        ...state,
        categoryId:  action.payload
      };
    case "SET_ACTIVE_CHATS":
      // Deduplicate active chats based on channel_id to prevent key errors
      const uniqueActiveChats = action.payload.reduce((acc, current) => {
        const x = acc.find(item => item.channel_id === current.channel_id);
        if (!x) {
          return acc.concat([current]);
        } else {
          return acc;
        }
      }, []);
      return { 
        ...state,
        activeChats:  uniqueActiveChats
      };
    case "SET_LAST_MESSAGES":
      return { 
        ...state,
        lastMessages:  action.payload
      };
    case "SET_CHAT":
      return { 
        ...state,
        currentChat:  action.payload
      };
    case "SET_ACCOUNT_NO":
      return { 
        ...state,
        accountNo:  action.payload
      };
   case "SET_ACCOUNT_DATA":
      // Only update if the fetched data is for the currently active accountNo in the state.
      if (state.accountNo === action.payload.fetchedForAccountNo) {
        return { 
          ...state,
          accountData: action.payload.fetchedData,
          isAccountDataLoading: false, // Data is set for the current account, so loading is false
          _accountDataVersion: state._accountDataVersion + 1 // Increment version
        };
      } else {
        // Data is stale (for a previously selected account whose fetch just completed). Do not apply it.
        console.warn(`SET_ACCOUNT_DATA: Stale data received for account ${action.payload.fetchedForAccountNo}, but current account is ${state.accountNo}. Ignoring stale data.`);
        return state; // Return current state, effectively ignoring the stale data.
      }
    case "SET_NAVIGATION":
      return { 
        ...state,
        navigation:  action.payload
      };
      case "SET_TAB":
      return { 
        ...state,
        tab:  action.payload
      };
      case "SET_USER":
      return { 
        ...state,
        user:  action.payload
      };
        case "SET_CUSTOMER":
      return { 
        ...state,
        customer:  action.payload
      };
    case "RESET_ACCOUNT_VIEW": // New action
      return {
        ...state,
        accountData: null,
        accountNo: 0, // Reset accountNo to indicate it's pending
        isAccountDataLoading: true, // Set loading true immediately on reset
        navigation: [{ name: "Home", action: "SHOW_ADDRESS", icon: HomeIcon }], // Reset navigation
        tab: "Home", // Reset tab to Home
        _accountDataVersion: state._accountDataVersion + 1 // Also increment version on reset
      };
    case "FINISH_ACCOUNT_LOADING_WITHOUT_DATA": // New action
      return {
        ...state,
        isAccountDataLoading: false,
        // accountData should remain as it was (likely null from a RESET_ACCOUNT_VIEW)
      };
    default:
      return state;
  }
};

  const [state, dispatch] = useReducer(chatReducer, INITIAL_STATE);

  return (
    <ChatContext.Provider value={{ data: state, dispatch }}>
      {children}
    </ChatContext.Provider>
  );
};
